import ApplicationController from './application_controller';

/**
 * Reveals the "Admin schedule layout" field only when the user has chosen
 * "Admin" as their default schedule view.
 *
 * @controller schedule-settings
 */
export default class extends ApplicationController {
  static targets = ['adminLayout'];

  connect() {
    this.toggle();
  }

  toggle() {
    const selected = this.element.querySelector('input[name*="default_calendar_view"]:checked');
    const isAdmin = selected?.value === 'admin';
    this.adminLayoutTargets.forEach((element) => {
      element.hidden = !isAdmin;
    });
  }
}
